var impressum = "Στοιχεία έκδοσης";
var privacy = "Προστασία απορρήτου και Νομικές υποχρεώσεις";
var recallInfo = "Πληροφορίες ανάκλησης";
var signOut = "Αποσύνδεση";
var el_gr = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { el_gr as default, impressum, privacy, recallInfo, signOut };
